import { atom } from 'jotai';
import { IPrimaryComment } from 'shared/models';
import { $ArticleComments } from 'shared/atoms';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IArticleCommentLoadmoreParam {
  items: IPrimaryComment[];
  hasMore: string;
  cursor: number;
}

export const $ArticleCommentsLoadmore = safeAtomFamily((groupId: string) => {
  const a = atom(null, async (get, set, input: IArticleCommentLoadmoreParam) => {
    const comments = await get($ArticleComments(groupId));
    const { items } = comments;
    const { items: nextItems, hasMore: nextHasMore, cursor: nextCursor } = input;

    const output = {
      items: [...items, ...nextItems],
      hasMore: nextHasMore,
      cursor: nextCursor,
    };

    set($ArticleComments(groupId), output as any);
  });

  a.debugLabel = `$ArticleCommentsLoadmore+${encodeURIComponent(groupId)}`;

  return a;
});
